import {
  QSetReviewSubtaskQuestionNavigator,
  QSetReviewSubtaskReviewQuestionSection,
  QSetReviewSubtaskStartSection,
} from '@exam-management/qset-review-subtask-details';
import { ReviewResultQuestion } from '@exam-management/qset-review-subtask-exam-details';
import { Flex } from '@shared/components';

export default function QSetReviewExamDetailsPage() {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Flex
        sx={(theme) => ({
          p: theme.spacing(6),
          gap: theme.spacing(6),
          flexDirection: 'column',
          flex: 1,
        })}
      >
        <QSetReviewSubtaskStartSection />
        <QSetReviewSubtaskReviewQuestionSection />
        <ReviewResultQuestion />
      </Flex>
      <QSetReviewSubtaskQuestionNavigator />
    </Flex>
  );
}
